module.exports = firebase.performance;